import 'owl.carousel';
import editMode from './../utils/detect-edit-mode';

document.addEventListener('DOMContentLoaded', () => {

    $('.js-swipe-slider').owlCarousel({

        items: 3,
        autoWidth: true,
        slideTransition: 'ease',
        smartSpeed: 500

    });

  $('.js-full-slider.js-auto-play').owlCarousel({

    loop: true,
    items: 1,
    slideTransition: 'ease',
    smartSpeed: 1000,
    startPosition: 1,
    autoplay: true,
    autoplayTimeout: 7000,
    autoplaySpeed: 1500,
    dots: false,
    nav: true,
    navText: [$('.slider-full__btn_left'), $('.slider-full__btn_right')],
    mouseDrag: false

  });

    $('.js-full-slider').owlCarousel({

        loop: true,
        items: 1,
        slideTransition: 'ease',
        smartSpeed: 500,
        startPosition: 1,
        nav: true,
        navText: [$('.slider-full__btn_left'), $('.slider-full__btn_right')],
        mouseDrag: false

    });

    if (editMode()) {

        $('.js-swipe-slider').owlCarousel('destroy');
        $('.js-full-slider').owlCarousel('destroy');

    }

});


// WEBPACK FOOTER //
// ./scripts/blocks/slider.js